import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    recentActivity: 'Recent activity',
    myActivity: 'My activity',
    copyAddress: 'Copy address',
    disconnectWallet: 'Disconnect wallet',
  },
};
